(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)];
  const config = JSON.parse($('#storefront-config')?.textContent || '{}');
  const root = (config.root || '/').replace(/\/?$/, '/');
  const storageKey = `hy-wishlist:${config.shop || location.hostname}`;
  const money = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency || 'EUR' }).format(Number(amount) / 100);
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeURL = (value) => { try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; } };
  const image = (url, title, className = '') => url ? `<img src="${escape(safeURL(url))}" alt="${escape(title)}" class="${className}" loading="lazy">` : '';
  const announce = (text) => { const node = $('[data-global-status]'); if (node) node.textContent = text; };
  let activeDrawer = null;
  let returnFocus = null;
  let cartBusy = false;
  let cartRead = 0;
  let saved = [];
  try { const stored = JSON.parse(localStorage.getItem(storageKey) || '[]'); if (Array.isArray(stored)) saved = stored.filter((h) => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)).slice(0, 100); } catch { /* Storage can be disabled; saving reports the error. */ }

  function closeDrawers(restore = true) {
    $$('.drawer').forEach((drawer) => { drawer.classList.remove('is-open'); drawer.inert = true; });
    $$('.site-header, #MainContent, .footer').forEach((node) => { node.inert = false; });
    document.body.classList.remove('drawer-open');
    const scrim = $('.drawer-scrim'); if (scrim) scrim.hidden = true;
    $$('[data-drawer-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    activeDrawer = null;
    if (restore && returnFocus?.isConnected) returnFocus.focus();
  }

  function openDrawer(id, opener) {
    const drawer = $(id); if (!drawer) return;
    if (!activeDrawer) returnFocus = opener || document.activeElement;
    closeDrawers(false);
    $$('details.mega-menu[open]').forEach((menu) => { menu.open = false; });
    drawer.inert = false; drawer.classList.add('is-open'); activeDrawer = drawer;
    $$('.site-header, #MainContent, .footer').forEach((node) => { if (!node.contains(drawer)) node.inert = true; });
    document.body.classList.add('drawer-open');
    const scrim = $('.drawer-scrim'); if (scrim) scrim.hidden = false;
    opener?.setAttribute('aria-expanded', 'true');
    ($('input:not([type=hidden])', drawer) || $('button, a', drawer))?.focus({preventScroll:true});
    if (id === '#wishlist-drawer') renderWishlist();
    if (id === '#cart-drawer' && !cartBusy) refreshCart().catch(() => cartStatus('Unable to refresh your bag. Please use View shopping bag.'));
  }

  async function request(url, options) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Unable to complete the request. Please try again.');
    return data;
  }
  function cartStatus(message) { const node = $('[data-cart-status]'); if (node) node.textContent = message; }
  function renderCartHTML(html) {
    if (!html) throw new Error('Cart view unavailable');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('#cart-content', parsed); const current = $('#cart-content');
    if (!fresh || !current) throw new Error('Cart view unavailable');
    current.replaceWith(fresh);
    $$('[data-cart-count]').forEach((count) => { count.textContent = fresh.dataset.count; count.hidden = Number(fresh.dataset.count) === 0; });
  }
  async function refreshCart() {
    const version = ++cartRead;
    const sections = await request(`${root}?sections=cart-panel`);
    if (version === cartRead) { renderCartHTML(sections['cart-panel']); cartStatus(''); }
  }
  async function changeCart(button) {
    if (cartBusy) return;
    cartBusy = true; ++cartRead; cartStatus('Updating…');
    $$('[data-cart-key]').forEach((node) => { node.disabled = true; });
    try {
      const result = await request(`${root}cart/change.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: button.dataset.cartKey, quantity: Number(button.dataset.cartQuantity), sections: ['cart-panel'], sections_url: root }) });
      try { renderCartHTML(result.sections?.['cart-panel']); } catch { await refreshCart(); }
      cartStatus(''); announce('Shopping bag updated');
      const next = $$('[data-cart-key]').find((el) => el.dataset.cartKey === button.dataset.cartKey);
      (next || $('[data-drawer-close]', $('#cart-drawer')))?.focus();
    } catch (error) { cartStatus(error.message); }
    finally { cartBusy = false; $$('[data-cart-key]').forEach((node) => { node.disabled = false; }); }
  }
  async function addToCart(form) {
    if (cartBusy) return;
    const button = $('[data-add-button]', form); const status = $('[data-product-status]', form);
    if (!form.reportValidity()) return;
    cartBusy = true; ++cartRead; button.disabled = true; button.textContent = 'Adding…'; if (status) status.textContent = '';
    const data = new FormData(form); data.append('sections', 'cart-panel'); data.append('sections_url', root);
    let added = false;
    try {
      const result = await request(`${root}cart/add.js`, { method: 'POST', body: data }); added = true;
      try { renderCartHTML(result.sections?.['cart-panel']); } catch { await refreshCart(); }
      openDrawer('#cart-drawer', button); announce('Added to shopping bag'); cartStatus('');
    } catch (error) { if (status) status.textContent = added ? 'Added to your bag. Open the shopping bag to continue.' : error.message; }
    finally { cartBusy = false; button.disabled = false; button.textContent = 'Add To Cart'; }
  }

  function syncSaved() {
    $$('[data-save-product]').forEach((button) => { const selected = saved.includes(button.dataset.saveProduct); button.setAttribute('aria-pressed', String(selected)); button.setAttribute('aria-label', selected ? 'Remove from saved items' : 'Save product'); });
    $$('[data-wishlist-dot]').forEach((dot) => { dot.hidden = saved.length === 0; });
  }
  function toggleSaved(handle) {
    const next = saved.includes(handle) ? saved.filter((h) => h !== handle) : [...saved, handle];
    try { localStorage.setItem(storageKey, JSON.stringify(next)); saved = next; }
    catch { announce('Your browser could not save this item. Allow site storage and try again.'); return; }
    syncSaved(); announce(saved.includes(handle) ? 'Saved to your wishlist' : 'Removed from your wishlist');
    if (activeDrawer?.id === 'wishlist-drawer') renderWishlist();
  }
  let wishlistVersion = 0;
  async function renderWishlist() {
    const target = $('[data-wishlist-items]'); if (!target) return;
    const version = ++wishlistVersion;
    if (!saved.length) { target.innerHTML = '<div class="cart-empty"><p>Your saved items will appear here.</p><p class="muted">Select the bookmark on a product to save it.</p></div>'; return; }
    target.textContent = 'Loading saved items…';
    const results = await Promise.allSettled(saved.map((handle) => request(`${root}products/${encodeURIComponent(handle)}.js`)));
    if (version !== wishlistVersion) return;
    target.innerHTML = results.map((result, i) => {
      const handle = saved[i];
      if (result.status !== 'fulfilled') return `<article class="saved-item"><div class="saved-item__image"></div><div><p>Product currently unavailable</p><button class="text-link" data-save-product="${escape(handle)}">Remove</button></div></article>`;
      const product = result.value;
      return `<article class="saved-item"><a class="saved-item__image" href="${root}products/${escape(product.handle)}">${image(product.featured_image, product.title)}</a><div><a href="${root}products/${escape(product.handle)}">${escape(product.title)}</a><p>${money(product.price)}</p><button class="text-link" data-quick-view="${escape(product.handle)}">Select size</button><p><button class="text-link" data-save-product="${escape(product.handle)}">Remove</button></p></div></article>`;
    }).join(''); syncSaved();
  }

  let searchTimer; let searchController; let searchVersion = 0;
  function searchProducts(input) {
    clearTimeout(searchTimer); searchController?.abort(); const version = ++searchVersion;
    const query = input.value.trim(); const results = $('[data-predictive-results]'); const status = $('[data-search-status]'); const suggestions = $('[data-search-suggestions]');
    if (!query) { results.replaceChildren(); status.textContent = ''; if (suggestions) suggestions.hidden = false; return; }
    if (suggestions) suggestions.hidden = true; status.textContent = 'Searching…'; results.replaceChildren();
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      try {
        const params = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'6',section_id:'predictive-search'});
        const response = await fetch(`${root}search/suggest?${params}`, {signal:searchController.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text(); if (version !== searchVersion) return;
        const fragment = new DOMParser().parseFromString(html, 'text/html'); const content = $('[data-search-response]', fragment);
        if (!content) throw new Error('Search unavailable'); results.replaceChildren(content); status.textContent = '';
      } catch (error) { if (error.name !== 'AbortError' && version === searchVersion) status.textContent = 'Press Enter to view search results.'; }
    }, 250);
  }

  let quickVersion = 0;
  async function quickView(handle, opener) {
    const version = ++quickVersion; openDrawer('#quick-view-drawer', opener);
    const target = $('[data-quick-content]'); target.textContent = 'Loading…';
    try {
      const product = await request(`${root}products/${encodeURIComponent(handle)}.js`); if (version !== quickVersion) return;
      const options = product.variants.map((variant) => `<option value="${variant.id}" ${variant.available ? '' : 'disabled'}>${escape(variant.title)} — ${money(variant.price)}${variant.available ? '' : ' — Sold out'}</option>`).join('');
      const hasStock = product.variants.some((variant) => variant.available);
      target.innerHTML = `${product.featured_image ? image(product.featured_image, product.title, 'quick-view__image') : '<div class="quick-view__image"></div>'}<h3>${escape(product.title)}</h3><p>${money(product.price)}</p><form data-product-form><label for="QuickVariant">Select option</label><select id="QuickVariant" name="id" required><option value="" selected disabled>Select size / option</option>${options}</select><input type="hidden" name="quantity" value="1"><button type="submit" class="button" data-add-button ${hasStock ? '' : 'disabled'}>${hasStock ? 'Add To Cart' : 'Sold out'}</button><p data-product-status role="status"></p></form><p><a class="text-link" href="${root}products/${escape(product.handle)}">View full details</a></p>`;
    } catch { if (version === quickVersion) target.textContent = 'Unable to load this product. Please open its product page.'; }
  }
  function updateVariant(scope, initial = false) {
    const variants = JSON.parse($('[data-product-variants]', scope).textContent);
    const groups = $$('[data-option-position]', scope);
    const chosen = groups.map((group) => $('input:checked', group)?.value);
    const variant = variants.find((v) => v.options.every((value, i) => value === chosen[i]));
    const select = $('[data-variant-id]', scope); const button = $('[data-add-button]', scope);
    select.value = variant ? String(variant.id) : ''; button.disabled = !variant?.available; button.textContent = variants.every(v => !v.available) ? 'Sold out' : chosen.some(value => !value) ? 'Select size / option' : variant ? variant.available ? 'Add To Cart' : 'Sold out' : 'Unavailable';
    if (variant) {
      $('[data-product-price]', scope).textContent = variant.price;
      if (!initial) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      if (variant.mediaId) { const media = $(`#media-${variant.mediaId}`, scope); const gallery = $('.product-media', scope); if (media && matchMedia('(max-width:749px)').matches) gallery.scrollTo({left:media.offsetLeft - gallery.offsetLeft,behavior:'smooth'}); else if (media) gallery.prepend(media); }
    }
    groups.forEach((group, i) => { $$('input', group).forEach((input) => { const exists = variants.some((v) => v.available && v.options[i] === input.value && v.options.every((value, j) => j >= i || !chosen[j] || value === chosen[j])); input.disabled = !exists; }); });
  }

  function selectMenuCategory(button) {
    const panel = button.closest('.tiered-menu');
    if (!panel) return;
    $$('[data-menu-category]', panel).forEach(item => item.setAttribute('aria-expanded', String(item === button)));
    $$('[data-menu-subcategory]', panel).forEach(item => { item.hidden = item.id !== button.dataset.menuCategory; });
  }
  function syncMegaMenu() {
    const opened = $('details.mega-menu[open]');
    document.body.classList.toggle('mega-menu-open', Boolean(opened));
    if (!activeDrawer) $$('#MainContent, .footer').forEach(node => { node.inert = Boolean(opened); });
    if (opened) opened.style.setProperty('--menu-top', `${Math.max(0, $('.site-header').getBoundingClientRect().bottom)}px`);
  }
  document.addEventListener('toggle', event => {
    if (!event.target.matches('details.mega-menu')) return;
    if (!event.target.open) {
      $$('[data-menu-category]', event.target).forEach(button => button.setAttribute('aria-expanded', 'false'));
      $$('[data-menu-subcategory]', event.target).forEach(panel => { panel.hidden = true; });
    }
    syncMegaMenu();
  }, true);
  document.addEventListener('pointerover', event => {
    const button = event.target.closest('[data-menu-category]');
    if (button && event.pointerType === 'mouse') selectMenuCategory(button);
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-menu-category]');
    if (button && event.key === 'ArrowRight') {
      event.preventDefault(); selectMenuCategory(button);
      $('a', document.getElementById(button.dataset.menuCategory))?.focus();
    }
    const panel = event.target.closest('[data-menu-subcategory]');
    if (panel && event.key === 'ArrowLeft') {
      event.preventDefault(); document.getElementById(panel.getAttribute('aria-labelledby'))?.focus();
    }
  });
  window.addEventListener('resize', () => {
    if (matchMedia('(max-width:749px)').matches) $$('details.mega-menu[open]').forEach(menu => { menu.open = false; });
    else if (activeDrawer?.id === 'menu-drawer') closeDrawers(false);
    syncMegaMenu();
  });
  document.addEventListener('click', (event) => {
    const category = event.target.closest('[data-menu-category]');
    if (category) selectMenuCategory(category);
    const closeMenu = event.target.closest('[data-mega-close]');
    if (closeMenu) { const menu = closeMenu.closest('details.mega-menu'); menu.open = false; $('summary', menu)?.focus(); }
    if (event.target.closest('a[href="#FooterContact"]')) { const details = $('#FooterContact details'); if (details) details.open = true; }
    const navigationLink = event.target.closest('#menu-drawer a[href], .mega-menu__panel a[href]');
    if (navigationLink) {
      if (activeDrawer?.id === 'menu-drawer') closeDrawers();
      $$('details.mega-menu[open]').forEach(menu => { menu.open = false; });
    }
    const menuSummary = event.target.closest('.mega-menu > summary');
    if (menuSummary) $$('details.mega-menu').forEach(menu => { if (menu !== menuSummary.parentElement) menu.open = false; });
    if (!event.target.closest('.nav-item')) $$('details.mega-menu[open]').forEach(menu => { menu.open = false; });
    const menuLink = event.target.closest('[data-mobile-menu-go]');
    if (menuLink) {
      const menu = $('#menu-drawer');
      const views = $$('[data-mobile-menu-view]', menu);
      const next = views.find(view => view.dataset.mobileMenuView === menuLink.dataset.mobileMenuGo);
      if (next) {
        views.forEach(view => { view.hidden = view !== next; });
        $('.mobile-menu-body', menu).scrollTop = 0;
        ($('.mobile-menu-back', next) || $('[aria-current=true]', next) || $('button, a', next))?.focus({preventScroll:true});
      }
    }
    const opener = event.target.closest('[data-drawer-open]'); if (opener && $(opener.dataset.drawerOpen)) { event.preventDefault(); openDrawer(opener.dataset.drawerOpen, opener); }
    if (event.target.closest('[data-drawer-close]')) closeDrawers();
    const save = event.target.closest('[data-save-product]'); if (save) { event.preventDefault(); toggleSaved(save.dataset.saveProduct); }
    const quick = event.target.closest('[data-quick-view]'); if (quick) quickView(quick.dataset.quickView, quick);
    const cart = event.target.closest('[data-cart-key]'); if (cart) changeCart(cart);
    const grid = event.target.closest('[data-grid-columns]'); if (grid) { $('.collection-section .product-grid')?.style.setProperty('--grid-columns', grid.dataset.gridColumns); $$('[data-grid-columns]').forEach((b) => b.setAttribute('aria-pressed', String(b === grid))); }
    const more = event.target.closest('[data-read-more]'); if (more) { const content = document.getElementById(more.dataset.readMore); const collapsed = content.classList.toggle('collapsed'); more.setAttribute('aria-expanded', String(!collapsed)); more.textContent = collapsed ? 'Read more' : 'Read less'; }
    const zoom = event.target.closest('[data-zoom-src]'); if (zoom) { const dialog = $('[data-media-zoom]'); $('img', dialog).src = zoom.dataset.zoomSrc; dialog.showModal(); }
    if (event.target.closest('[data-zoom-close]')) $('[data-media-zoom]').close();
  });
  document.addEventListener('input', (event) => { if (event.target.matches('[data-predictive-input]')) searchProducts(event.target); });
  document.addEventListener('change', (event) => { if (event.target.closest('[data-option-position]')) updateVariant(event.target.closest('[data-product-root]')); });
  document.addEventListener('submit', (event) => { if (event.target.matches('[data-product-form]')) { event.preventDefault(); addToCart(event.target); } });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { closeDrawers(); $$('details.mega-menu[open]').forEach((menu) => { menu.open = false; $('summary', menu)?.focus(); }); }
    if (event.key !== 'Tab' || !activeDrawer) return;
    const focusable = $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select:not([disabled]),summary', activeDrawer).filter((el) => el.getClientRects().length);
    const first = focusable[0]; const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  window.addEventListener('storage', (event) => { if (event.key === storageKey) { try { const value = JSON.parse(event.newValue || '[]'); if (Array.isArray(value)) saved = value.filter((h) => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)); syncSaved(); if (activeDrawer?.id === 'wishlist-drawer') renderWishlist(); } catch { /* Ignore malformed storage. */ } } });
  document.addEventListener('shopify:section:load', syncSaved);
  $$('[data-product-root]').forEach(scope => { if ($('[data-option-position]', scope)) updateVariant(scope, true); });
  syncSaved();
})();
